
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'crmcustomerarchiveIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'crmcustomerarchive',
				windowName: 'crmcustomerarchive',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			
		}
	}
</script>
